export default __webpack_public_path__ + "static/media/cz.b90ac623.jpg";